import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-794af1d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clubMembers" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 center mb-4" }, "Klubmedlemmer", -1))
const _hoisted_3 = { class: "clubMembersContainer" }
const _hoisted_4 = { class: "layout gutter--lg" }
const _hoisted_5 = { class: "row justify--center align--center" }
const _hoisted_6 = { class: "md1 flex mobile" }
const _hoisted_7 = {
  class: "md6 flex",
  style: {"display":"flex"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_9 = { class: "flex md2" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Forny licenser")
const _hoisted_11 = { class: "flex md2" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Medlemsopgørelse")
const _hoisted_13 = { class: "va-table-responsive" }
const _hoisted_14 = {
  class: "va-table va-table--striped membersTable",
  style: {"width":"100%"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center mobile" }, "Holdkaptajn", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Handlinger", -1))
const _hoisted_17 = { class: "clubMembersTable" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "clubMembersTable mobile" }
const _hoisted_20 = { class: "center clubMembersTable mobile" }
const _hoisted_21 = { class: "center clubMembersTable mobile" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "center clubMembersTable mobilePortraits" }
const _hoisted_24 = { class: "clubMembersTable" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Frigør")
const _hoisted_26 = { class: "editMemberMailAddressModal" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md12 flex" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mb-4",
    style: {"font-size":"1.2em"}
  }, "Rediger mailadresse for medlemmet")
], -1))
const _hoisted_28 = { class: "row justify--center" }
const _hoisted_29 = {
  class: "md6 flex",
  style: {"font-size":"1.2em!important"}
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Opdater mail")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "center display-4" }, "Medlemsopgørelse", -1))
const _hoisted_33 = { class: "row justify--center" }
const _hoisted_34 = { class: "flex" }
const _hoisted_35 = {
  key: 0,
  class: "va-table-responsive"
}
const _hoisted_36 = { class: "va-table va-table--striped statics" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Kategori"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Mænd/drenge"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Kvinder/piger")
  ])
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "0-6 år", -1))
const _hoisted_39 = { class: "center" }
const _hoisted_40 = { class: "center" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "7-12 år", -1))
const _hoisted_42 = { class: "center" }
const _hoisted_43 = { class: "center" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "13-18 år", -1))
const _hoisted_45 = { class: "center" }
const _hoisted_46 = { class: "center" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "19-24 år", -1))
const _hoisted_48 = { class: "center" }
const _hoisted_49 = { class: "center" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "25-39 år", -1))
const _hoisted_51 = { class: "center" }
const _hoisted_52 = { class: "center" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "40-59 år", -1))
const _hoisted_54 = { class: "center" }
const _hoisted_55 = { class: "center" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "60-69 år", -1))
const _hoisted_57 = { class: "center" }
const _hoisted_58 = { class: "center" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "70+ år", -1))
const _hoisted_60 = { class: "center" }
const _hoisted_61 = { class: "center" }
const _hoisted_62 = { colspan: "3" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "Bestyrelse, ledere, instruktrører 0-24", -1))
const _hoisted_64 = { class: "center" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "Bestyrelse, ledere, instruktører 25+", -1))
const _hoisted_66 = { class: "center" }
const _hoisted_67 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_68 = { class: "va-table va-table--striped statics" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Kategori"),
    /*#__PURE__*/_createElementVNode("th", null, "Antal")
  ])
], -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "0-24 år", -1))
const _hoisted_71 = { class: "center" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "25-64", -1))
const _hoisted_73 = { class: "center" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "65+", -1))
const _hoisted_75 = { class: "center" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, null, -1))
const _hoisted_77 = { colspan: "2" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Frivillige", -1))
const _hoisted_79 = { class: "center" }
const _hoisted_80 = { class: "row justify--center" }
const _hoisted_81 = { class: "flex" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Licensfornyelser", -1))
const _hoisted_84 = { class: "layout gutter--xl" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--space-around" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex md6" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Forny licens for:")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex md4" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Pris:")
  ])
], -1))
const _hoisted_86 = { class: "row justify--space-around" }
const _hoisted_87 = { class: "flex md6" }
const _hoisted_88 = { class: "flex md4" }
const _hoisted_89 = { class: "row mt-4 justify--center" }
const _hoisted_90 = { class: "flex" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode("Køb nu")
const _hoisted_92 = { class: "row justify--center" }
const _hoisted_93 = { class: "flex" }
const _hoisted_94 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Frigør medlem", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info center" }, "Er du sikker på at du vil frigør medlemmet?", -1))
const _hoisted_97 = { class: "row justify--center" }
const _hoisted_98 = { class: "flex" }
const _hoisted_99 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_100 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Medlemsinformation", -1))
const _hoisted_102 = { class: "layout gutter--lg memberInfoContainer" }
const _hoisted_103 = { class: "row justify--space-around align--center" }
const _hoisted_104 = { class: "flex md8 xs12" }
const _hoisted_105 = { class: "extraInfo" }
const _hoisted_106 = /*#__PURE__*/_createTextVNode("Navn: ")
const _hoisted_107 = { class: "flex md4 xs12" }
const _hoisted_108 = { class: "extraInfo" }
const _hoisted_109 = /*#__PURE__*/_createTextVNode("Licens: ")
const _hoisted_110 = { class: "row justify--space-around align--center" }
const _hoisted_111 = { class: "flex md5 xs12 sm6" }
const _hoisted_112 = { class: "extraInfo" }
const _hoisted_113 = /*#__PURE__*/_createTextVNode("Brugernavn: ")
const _hoisted_114 = { class: "flex md3 xs12 sm6" }
const _hoisted_115 = { class: "extraInfo" }
const _hoisted_116 = /*#__PURE__*/_createTextVNode("Køn: ")
const _hoisted_117 = { class: "flex md4 xs12 sm6" }
const _hoisted_118 = { class: "extraInfo" }
const _hoisted_119 = /*#__PURE__*/_createTextVNode("Licens udløber: ")
const _hoisted_120 = { class: "row justify--space-around align--center" }
const _hoisted_121 = { class: "flex md4 xs12 sm6" }
const _hoisted_122 = { class: "extraInfo" }
const _hoisted_123 = /*#__PURE__*/_createTextVNode("Født: ")
const _hoisted_124 = { class: "flex md3 xs12 sm6" }
const _hoisted_125 = { class: "extraInfo" }
const _hoisted_126 = /*#__PURE__*/_createTextVNode("Paradart: ")
const _hoisted_127 = { class: "flex md5 xs12 sm6" }
const _hoisted_128 = { class: "extraInfo" }
const _hoisted_129 = /*#__PURE__*/_createTextVNode("Klub: ")
const _hoisted_130 = {
  key: 0,
  class: "row justify--space-around align--center"
}
const _hoisted_131 = { class: "flex md6 xs12 sm6" }
const _hoisted_132 = { class: "extraInfo" }
const _hoisted_133 = /*#__PURE__*/_createTextVNode("Telefon: ")
const _hoisted_134 = ["href"]
const _hoisted_135 = { class: "flex md6 xs12 sm6" }
const _hoisted_136 = { class: "extraInfo" }
const _hoisted_137 = /*#__PURE__*/_createTextVNode("Email: ")
const _hoisted_138 = ["href"]
const _hoisted_139 = {
  key: 1,
  class: "row justify--space-around align--center"
}
const _hoisted_140 = { class: "flex md6 xs12 sm6" }
const _hoisted_141 = { class: "flex md6 xs12 sm6" }
const _hoisted_142 = {
  key: 2,
  class: "row justify--space-around align--center"
}
const _hoisted_143 = { class: "flex md6 xs12 sm6" }
const _hoisted_144 = { class: "extraInfo" }
const _hoisted_145 = /*#__PURE__*/_createTextVNode("Vej og husnr.: ")
const _hoisted_146 = { class: "flex md3 xs6 sm6" }
const _hoisted_147 = { class: "extraInfo" }
const _hoisted_148 = /*#__PURE__*/_createTextVNode("Postnr.: ")
const _hoisted_149 = { class: "flex md3 xs6 sm6" }
const _hoisted_150 = { class: "extraInfo" }
const _hoisted_151 = /*#__PURE__*/_createTextVNode("By: ")
const _hoisted_152 = {
  key: 3,
  class: "row justify--space-around align--center"
}
const _hoisted_153 = { class: "flex md6 xs12 sm6" }
const _hoisted_154 = { class: "flex md3 xs6 sm6" }
const _hoisted_155 = { class: "flex md3 xs6 sm6" }
const _hoisted_156 = { class: "row justify--space-around align--center" }
const _hoisted_157 = { class: "flex md4 xs12 sm6" }
const _hoisted_158 = { class: "extraInfo" }
const _hoisted_159 = /*#__PURE__*/_createTextVNode("Sidste kamp: ")
const _hoisted_160 = { class: "flex md3 xs12 sm6" }
const _hoisted_161 = { class: "extraInfo" }
const _hoisted_162 = /*#__PURE__*/_createTextVNode("Sidste login: ")
const _hoisted_163 = { class: "flex md5 xs12 sm6" }
const _hoisted_164 = { class: "extraInfo" }
const _hoisted_165 = /*#__PURE__*/_createTextVNode("Karantæne: ")
const _hoisted_166 = { class: "layout gutter--lg memberInfoContainer mt-4" }
const _hoisted_167 = { class: "row justify--space-around" }
const _hoisted_168 = { class: "flex md6 align-self-start" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "extraInfo center mb-2" }, "Medlemshistorik", -1))
const _hoisted_170 = { class: "memberHistoryContainer" }
const _hoisted_171 = { class: "extraInfo" }
const _hoisted_172 = { class: "flex md6 align-self-start" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "extraInfo center mb-2" }, "Handlinger", -1))
const _hoisted_174 = { class: "row justify--center align--center" }
const _hoisted_175 = { class: "flex" }
const _hoisted_176 = { class: "row justify--center align--center" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
    /*#__PURE__*/_createElementVNode("i", null, "* Har allerede flere rettigheder end en holdkaptajn")
  ])
], -1))
const _hoisted_178 = [
  _hoisted_177
]
const _hoisted_179 = { class: "row justify--center align--center" }
const _hoisted_180 = { class: "flex" }
const _hoisted_181 = { class: "row justify--center" }
const _hoisted_182 = { class: "flex" }
const _hoisted_183 = /*#__PURE__*/_createTextVNode("Redigere")
const _hoisted_184 = /*#__PURE__*/_createTextVNode("Opdater")
const _hoisted_185 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_186 = /*#__PURE__*/_createTextVNode("Luk")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_radio = _resolveComponent("va-radio")!
  const _component_it_modal = _resolveComponent("it-modal")!
  const _component_va_select = _resolveComponent("va-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.columnSort('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.memberSearchInputValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.memberSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.findMember()), ["enter"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "person_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.findMember()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.renewLicenses()))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_va_button, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.membershipStatics()))
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(_component_it_divider),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("table", _hoisted_14, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createVNode(_component_va_popover, {
                  class: "popoverTable",
                  message: "Vælg alle",
                  placement: "left"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_checkbox, {
                      modelValue: _ctx.licenseCheckAll,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.licenseCheckAll) = $event)),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectAll()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("th", {
                class: "sorting",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.columnSort('name')))
              }, "Navn"),
              _createElementVNode("th", {
                class: "sorting mobile",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.columnSort('license')))
              }, "Licens"),
              _hoisted_15,
              _createElementVNode("th", {
                class: "center sorting mobile",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.columnSort('telephone')))
              }, "Telefon"),
              _createElementVNode("th", {
                class: "center sorting mobile",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.columnSort('email')))
              }, "Email"),
              _createElementVNode("th", {
                class: "center sorting mobilePortraits",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.columnSort('role')))
              }, "Klubrolle"),
              _hoisted_16
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clubMembers, (member) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: member.id
              }, [
                _createElementVNode("td", _hoisted_17, [
                  _createVNode(_component_va_checkbox, {
                    modelValue: _ctx.checked,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.checked) = $event)),
                    "array-value": (member),
                    disabled: _ctx.disableLicenseRenewal(member.medlem_licens_slut)
                  }, null, 8, ["modelValue", "array-value", "disabled"])
                ]),
                _createElementVNode("td", {
                  class: "sorting clubMembersTable",
                  onClick: ($event: any) => (_ctx.extraInfo(member.id))
                }, _toDisplayString(member.user_id.firstname + ' ' + member.user_id.lastname), 9, _hoisted_18),
                _createElementVNode("td", _hoisted_19, _toDisplayString(member.medlem_licens), 1),
                _createElementVNode("td", _hoisted_20, [
                  (_ctx.canBecomeCaptain(member.user_id.usrgroup))
                    ? (_openBlock(), _createBlock(_component_va_icon, {
                        key: 0,
                        onClick: ($event: any) => (_ctx.changeTeamCaptainStatus(member.user_id.id, member.user_id.usrgroup)),
                        name: _ctx.teamCaptain(member.user_id.usrgroup) ? 'star' : 'star_border',
                        color: _ctx.teamCaptain(member.user_id.usrgroup) ? '#ffd700' : ''
                      }, null, 8, ["onClick", "name", "color"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_21, _toDisplayString((member.user_id.phone === null ? 'Ikke opgivet' : member.user_id.phone)), 1),
                _createElementVNode("td", {
                  class: "center clubMembersTable mobile",
                  onClick: ($event: any) => (_ctx.editClubMemberMailAddress(member.user_id.id))
                }, _toDisplayString((member.user_id.email === null ? 'Ikke opgivet' : member.user_id.email)), 9, _hoisted_22),
                _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.convertClubRoleEnum(member.medlem_klubrolle)), 1),
                _createElementVNode("td", _hoisted_24, [
                  _createVNode(_component_va_button, {
                    class: "btn",
                    size: "small",
                    color: "danger",
                    onClick: ($event: any) => (_ctx.releaseMemberWarning(member.id))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.editMemberMailAddressModal,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editMemberMailAddressModal) = $event)),
      size: "small",
      "hide-default-actions": "",
      "overlay-opacity": "0.5"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_va_input, {
                class: "mb-4",
                modelValue: _ctx.newMemberMailAddress,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newMemberMailAddress) = $event)),
                type: "text",
                label: "Ny mailadresse",
                bordered: ""
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createVNode(_component_va_button, {
          class: "btn mr-4",
          color: "success",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updateMemberMailAddress()))
        }, {
          default: _withCtx(() => [
            _hoisted_30
          ]),
          _: 1
        }),
        _createVNode(_component_va_button, {
          class: "btn mr-4",
          color: "secondary",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editMemberMailAddressModal = false)))
        }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.memberStatisticsModal,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.memberStatisticsModal) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_32,
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statisticsOptions, (option, index) => {
              return (_openBlock(), _createBlock(_component_va_radio, {
                key: index,
                modelValue: _ctx.selectedStatistics,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectedStatistics) = $event)),
                option: option
              }, null, 8, ["modelValue", "option"]))
            }), 128))
          ])
        ]),
        (_ctx.selectedStatistics === 'DIF')
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("table", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_38,
                    _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.getMembershipNumber(0, 6, 'male')), 1),
                    _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.getMembershipNumber(0, 6, 'female')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_41,
                    _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.getMembershipNumber(7, 12, 'male')), 1),
                    _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.getMembershipNumber(7, 12, 'female' )), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_44,
                    _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.getMembershipNumber(13, 18, 'male')), 1),
                    _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.getMembershipNumber(13, 18, 'female')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_47,
                    _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.getMembershipNumber(19, 24, 'male')), 1),
                    _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.getMembershipNumber(19, 24, 'female')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_50,
                    _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.getMembershipNumber(25, 39, 'male')), 1),
                    _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.getMembershipNumber(25, 39, 'female')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_53,
                    _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.getMembershipNumber(40, 59, 'male')), 1),
                    _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.getMembershipNumber(40, 59, 'female')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_56,
                    _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.getMembershipNumber(60, 69, 'male')), 1),
                    _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.getMembershipNumber(60, 69, 'female')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_59,
                    _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.getMembershipNumber(70, 150, 'male')), 1),
                    _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.getMembershipNumber(70, 150, 'female')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_62, [
                      _createVNode(_component_it_divider)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_63,
                    _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.getClubManagers(0, 24)), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_65,
                    _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.getClubManagers(25, 150)), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedStatistics === 'Kommunen')
          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
              _createElementVNode("table", _hoisted_68, [
                _hoisted_69,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_70,
                    _createElementVNode("td", _hoisted_71, _toDisplayString(_ctx.getMembershipNumber(0, 24, 'both')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_72,
                    _createElementVNode("td", _hoisted_73, _toDisplayString(_ctx.getMembershipNumber(25, 64, 'both')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_74,
                    _createElementVNode("td", _hoisted_75, _toDisplayString(_ctx.getMembershipNumber(65, 150, 'both')), 1)
                  ]),
                  _hoisted_76,
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_77, [
                      _createVNode(_component_it_divider)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_78,
                    _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.getClubManagers(0, 150)), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _createVNode(_component_va_button, {
              color: "secondary",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.memberStatisticsModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_82
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.renewLicensesModal,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.renewLicensesModal) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_83,
        _createElementVNode("div", _hoisted_84, [
          _hoisted_85,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checked, (member) => {
            return (_openBlock(), _createElementBlock("div", {
              key: member.id
            }, [
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("p", null, _toDisplayString(member.user_id.firstname + ' ' + member.user_id.lastname), 1)
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.calcLicensePrice(member.medlem_licens_slut, member.medlem_foedselsdag, _ctx.licenseProduct.produkt_pris, _ctx.juniorLicenseProduct.produkt_pris)) + " kr.", 1)
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _createVNode(_component_va_button, {
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addLicensesRenewalToCart()))
              }, {
                default: _withCtx(() => [
                  _hoisted_91,
                  _createVNode(_component_va_icon, { name: "shopping_cart" })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_92, [
          _createElementVNode("div", _hoisted_93, [
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.renewLicensesModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_94
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.releaseMemberModal,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.releaseMemberModal) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_95,
        _hoisted_96,
        _createElementVNode("div", _hoisted_97, [
          _createElementVNode("div", _hoisted_98, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.releaseMember(this.releaseMemberId)))
            }, {
              default: _withCtx(() => [
                _hoisted_99
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.releaseMemberModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_100
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.extraMemberInfoModal,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.extraMemberInfoModal) = $event)),
      width: "75%"
    }, {
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_181, [
          _createElementVNode("div", _hoisted_182, [
            (!_ctx.editMemberInformation)
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 0,
                  class: "mr-4",
                  color: "secondary",
                  onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.editMemberInfo()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_183
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.editMemberInformation)
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 1,
                  class: "mr-4",
                  color: "success",
                  onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.updateMemberInfo()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_184
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.editMemberInformation)
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 2,
                  class: "mr-4",
                  color: "danger",
                  onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.editMemberInformation = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_185
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.extraMemberInfoModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_186
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_101,
        _createElementVNode("div", _hoisted_102, [
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("p", _hoisted_105, [
                _hoisted_106,
                _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.firstName + ' ' + _ctx.memberData.lastName), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_107, [
              _createElementVNode("p", _hoisted_108, [
                _hoisted_109,
                _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.licenseNumber === null ? 0 : _ctx.memberData.licenseNumber), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("p", _hoisted_112, [
                _hoisted_113,
                _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.userName), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_114, [
              _createElementVNode("p", _hoisted_115, [
                _hoisted_116,
                _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.gender), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_117, [
              _createElementVNode("p", _hoisted_118, [
                _hoisted_119,
                _createElementVNode("strong", null, _toDisplayString(_ctx.expirationDate(_ctx.memberData.licenseExpires)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_120, [
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("p", _hoisted_122, [
                _hoisted_123,
                _createElementVNode("strong", null, _toDisplayString(_ctx.toDanishDateString(_ctx.memberData.birthDate)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_124, [
              _createElementVNode("p", _hoisted_125, [
                _hoisted_126,
                _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.paraDartPlayer ? 'Ja' : 'Nej'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("p", _hoisted_128, [
                _hoisted_129,
                _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.club), 1)
              ])
            ])
          ]),
          (!_ctx.editMemberInformation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                _createElementVNode("div", _hoisted_131, [
                  _createElementVNode("p", _hoisted_132, [
                    _hoisted_133,
                    _createElementVNode("strong", null, [
                      _createElementVNode("a", {
                        href: 'tel:' + _ctx.memberData.telephone
                      }, _toDisplayString(_ctx.memberData.telephone), 9, _hoisted_134)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_135, [
                  _createElementVNode("p", _hoisted_136, [
                    _hoisted_137,
                    _createElementVNode("strong", null, [
                      _createElementVNode("a", {
                        href: 'mailto:' + _ctx.memberData.email
                      }, _toDisplayString(_ctx.memberData.email), 9, _hoisted_138)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.editMemberInformation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                _createElementVNode("div", _hoisted_140, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.beforeEditMemberInformation.telephone,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.beforeEditMemberInformation.telephone) = $event)),
                    label: "Telefon",
                    bordered: "",
                    rules: [(v) => (v.length === 8 && !isNaN(v)) || 'Vi skal bruge et telefonnummer' ]
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_141, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.beforeEditMemberInformation.email,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.beforeEditMemberInformation.email) = $event)),
                    label: "Email",
                    bordered: "",
                    rules: [(v) => _ctx.checkEmail(v) || 'Angiv venligst en korrekt email adresse' ]
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.editMemberInformation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                _createElementVNode("div", _hoisted_143, [
                  _createElementVNode("p", _hoisted_144, [
                    _hoisted_145,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.address), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_146, [
                  _createElementVNode("p", _hoisted_147, [
                    _hoisted_148,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.postalNumber), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_149, [
                  _createElementVNode("p", _hoisted_150, [
                    _hoisted_151,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.city), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.editMemberInformation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                _createElementVNode("div", _hoisted_153, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.beforeEditMemberInformation.address,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.beforeEditMemberInformation.address) = $event)),
                    label: "Vej og husnr.:",
                    bordered: "",
                    rules: [(v) => v.length > 1 || 'Angiv en adresse']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_154, [
                  _createVNode(_component_va_input, {
                    type: "number",
                    modelValue: _ctx.beforeEditMemberInformation.postalNumber,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.beforeEditMemberInformation.postalNumber) = $event)),
                    label: "Post nr.",
                    bordered: "",
                    rules: [(v) => v.length === 4 || 'Postnr. mangler' ]
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_155, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    readonly: "",
                    modelValue: _ctx.beforeEditMemberInformation.city,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.beforeEditMemberInformation.city) = $event)),
                    label: "By",
                    bordered: "",
                    rules: [(v) => v.length > 1 || 'By mangler']
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_156, [
            _createElementVNode("div", _hoisted_157, [
              _createElementVNode("p", _hoisted_158, [
                _hoisted_159,
                _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.lastMatch), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_160, [
              _createElementVNode("p", _hoisted_161, [
                _hoisted_162,
                _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.lastLogin), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_163, [
              _createElementVNode("p", _hoisted_164, [
                _hoisted_165,
                _createElementVNode("strong", null, _toDisplayString((_ctx.testActiveQuarantine(_ctx.memberData.quarantineStartDate, _ctx.memberData.quarantineEndDate) ? 'Ja' : 'Nej')), 1),
                _createElementVNode("i", null, _toDisplayString((_ctx.testActiveQuarantine(_ctx.memberData.quarantineStartDate, _ctx.memberData.quarantineEndDate) ? ' Slutter: ' + _ctx.toDanishDateString(_ctx.memberData.quarantineEndDate) : '')), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_166, [
          _createElementVNode("div", _hoisted_167, [
            _createElementVNode("div", _hoisted_168, [
              _hoisted_169,
              _createElementVNode("div", _hoisted_170, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.memberHistory, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id
                  }, [
                    _createElementVNode("p", _hoisted_171, [
                      _createElementVNode("i", null, _toDisplayString(_ctx.toDanishDateString(item.created_at)), 1),
                      _createTextVNode(" - " + _toDisplayString(item.medlemshistorik_handling), 1)
                    ])
                  ]))
                }), 128)),
                (_ctx.memberHistory.length >= 5)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "showMore center sorting",
                      onClick: _cache[32] || (_cache[32] = ($event: any) => {_ctx.showCompleteHistory = !_ctx.showCompleteHistory; _ctx.retrieveMemberHistory(_ctx.memberData.memberId)})
                    }, _toDisplayString((_ctx.showCompleteHistory ? 'Vis færre' : 'Vis flere')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_172, [
              _hoisted_173,
              _createElementVNode("div", _hoisted_174, [
                _createElementVNode("div", _hoisted_175, [
                  _createVNode(_component_va_checkbox, {
                    modelValue: _ctx.memberData.teamCaptain,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.memberData.teamCaptain) = $event)),
                    label: _ctx.checkUserPermissions(_ctx.memberData.permissions) ? 'Holdkaptajn*' : 'Holdkaptajn',
                    disabled: _ctx.checkUserPermissions(_ctx.memberData.permissions)
                  }, null, 8, ["modelValue", "label", "disabled"])
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_176, _hoisted_178, 512), [
                [_vShow, _ctx.checkUserPermissions(_ctx.memberData.permissions)]
              ]),
              _createElementVNode("div", _hoisted_179, [
                _createElementVNode("div", _hoisted_180, [
                  _createVNode(_component_va_select, {
                    modelValue: _ctx.clubRoleStringValue,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.clubRoleStringValue) = $event)),
                    class: "center",
                    options: _ctx.clubRoleOptions,
                    label: "Klubrolle",
                    maxHeight: "90px"
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}